var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psConfigurationLink"},[_c('i',{staticClass:"icon",class:_vm.icon}),_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }